import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { Colors } from 'common-constants/colors'
import { FontSize } from 'common-constants/sizes'
import { useShowUserLocationAbTest } from 'components/block/GeoPermissionRequest/hooks/useShowUserLocationAbTest'
import { SeenRecentlyText } from 'components/block/GeoPermissionRequest/SeenRecentlyText'
import { requestGeoPermissionPath } from 'components/paths'
import { media } from 'components/presentational'
import { RouterLink } from 'components/presentational/link'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { GQLGender } from 'generated-graphql/graphql'
import { useLayoutContext } from 'hooks/useLayoutContext'

export const UserLocationAbTest: FC<{
  location: string
  online: boolean
  gender: GQLGender
}> = ({ location, online, gender }) => {
  const { baseUrl } = useLayoutContext()
  const { showUserLocation } = useShowUserLocationAbTest()

  return (
    <Message data-name="profile-location">
      {showUserLocation ? (
        location
      ) : (
        <AbTestText>
          <RouterLink to={mergeAllUrls(baseUrl, requestGeoPermissionPath)}>
            <FormattedMessage
              id="geolocation.to.know.distance"
              defaultMessage="Узнать расстояние"
            />
          </RouterLink>
          {!online && (
            <>
              {' '}
              <span>
                <SeenRecentlyText gender={gender} />
              </span>
            </>
          )}
        </AbTestText>
      )}
    </Message>
  )
}

export const Message = styled.div`
  max-width: 90%;
  margin-top: 5px;
  font-size: 13px;
  color: ${Colors.dark};

  ${media.tablet`
    color: ${Colors.white} 
  `}
`

const AbTestText = styled.div`
  font-size: ${FontSize.titleSubGiftCategory}px;
`
